import React from "react";

export default function Testimonial() {
  return (
    <>
      <section className="testimonial" id="testimonial">
        <h1 className="heading">testimonials</h1>
        <div className="box-container">
          <div className="box">
            <div className="comment">
              <i className="fa fa-quote-left" />
              <p>
                {" "}
                Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                Asperiores sequi libero quasi natus fugit laboriosam architecto
                atque. Aliquid, repudiandae neque.
              </p>
              <i className="fa fa-quote-right" />
            </div>
            <div className="user">
              <img src={"./images/pic1.png"} alt="" />
              <h3>web designer</h3>
              <div className="stars">
                <i className="fa fa-star" />
                <i className="fa fa-star" />
                <i className="fa fa-star" />
                <i className="fa fa-star" />
                <i className="fa fa-star" />
              </div>
            </div>
          </div>
          <div className="box">
            <div className="comment">
              <i className="fa fa-quote-left" />
              <p>
                {" "}
                Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                Asperiores sequi libero quasi natus fugit laboriosam architecto
                atque. Aliquid, repudiandae neque.
              </p>
              <i className="fa fa-quote-right" />
            </div>
            <div className="user">
              <img src={"./images/pic2.png"} alt="" />
              <h3>web designer</h3>
              <div className="stars">
                <i className="fa fa-star" />
                <i className="fa fa-star" />
                <i className="fa fa-star" />
                <i className="fa fa-star" />
                <i className="fas fa-star" />
              </div>
            </div>
          </div>
          <div className="box">
            <div className="comment">
              <i className="fa fa-quote-left" />
              <p>
                {" "}
                Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                Asperiores sequi libero quasi natus fugit laboriosam architecto
                atque. Aliquid, repudiandae neque.
              </p>
              <i className="fa fa-quote-right" />
            </div>
            <div className="user">
              <img src={"./images/pic3.png"} alt="" />
              <h3>web designer</h3>
              <div className="stars">
                <i className="fa fa-star" />
                <i className="fa fa-star" />
                <i className="fa fa-star" />
                <i className="fa fa-star" />
                <i className="fa fa-star" />
              </div>
            </div>
          </div>
          <div className="box">
            <div className="comment">
              <i className="fa fa-quote-left" />
              <p>
                {" "}
                Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                Asperiores sequi libero quasi natus fugit laboriosam architecto
                atque. Aliquid, repudiandae neque.
              </p>
              <i className="fa fa-quote-right" />
            </div>
            <div className="user">
              <img src={"./images/pic4.png"} alt="" />
              <h3>web designer</h3>
              <div className="stars">
                <i className="fa fa-star" />
                <i className="fa fa-star" />
                <i className="fa fa-star" />
                <i className="fa fa-star" />
                <i className="fa fa-star" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
